import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import * as sdkclaro from '@claropay/claro-pay-sdk-v2';
import "./index.css";
import AppMain from "./AppMain";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./store";
import { 
  SERVICE_ID_TELCEL_POSPAGO, 
  SERVICE_ID_TELCEL_PLANES,
  CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE,
  BUNDLE_ID_CONTAINER_TELCEL,
  SERVICE_ID_TELCEL_PAQUETES_POSPAGO,
  CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS,
  CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS_MIXTO,
  SERVICE_ID_TELCEL_PAQUETES_MIXTOS,
  OPEN_FLUX_ADD_CARD,
  OPEN_PAY_METHOD_MODAL
} from './constants';
import { useClaropaySdk } from "./services/sdk/SDKServiceWeb.tsx";
import { getDomiciliationWindowId } from "./components/organisms/utils.js";
import { register } from 'swiper/swiper-element-bundle';
import { EXECUTE_TAGGEO, SET_TOKENIZATION_CARD, setCanR1Success } from "./store/actions/index.js";
register();
import pjson from '../package.json';
console.log('Versión', pjson.version);

const history = createBrowserHistory();
export const store = configureStore(history);
sessionStorage.setItem("domiciliationWindowId", Math.floor(1000 + Math.random() * 9000).toString())

sdkclaro.getInstance(
  "XXXXXXX", 
  (apiKeySource, token, profileInformation, resourceInformation)=>{console.log('onLaunch')}, 
  (eventName, eventInformation)=>{console.log('onShow')}, 
  ()=>{console.log('onHide')}, 
  ()=>{console.log('onError')}, 
  (eventName,eventInformation)=>{
    console.log(eventName, 'eventName')
    console.log(eventInformation, 'eventInformation')
    if (eventName==='loggued_in_response') {
      store.dispatch({
        type: "SET_START_EVENT_LOGIN_IS_OVER",
        startEventLoginIsOver: true
      });
    }
    if (eventName==='onboarding_success') {
      store.dispatch({
        type: "SET_START_EVENT_ONBOARDING_IS_OVER",
        startEventOnboardingIsOver: true
      });
    }
    if(eventName==='_ONBACK_'){
      const stateTmp = store.getState();
      if(stateTmp.payments && stateTmp.payments.tokenizationCard && stateTmp.payments.tokenizationCard.open){
        let data = localStorage.getItem("tokenization_card_back");
        if (data) {
          data = JSON.parse(data);
          store.dispatch({
            type: EXECUTE_TAGGEO,
            params: {
              ...data.analytic,
              isAnonimous: data.isAnonimous,
            }
          });
        }
        if (!window.isValidationEmail) {
          store.dispatch({
            type: SET_TOKENIZATION_CARD,
            payload: {
              result: "declined",
            }
          });
        } else {
          localStorage.setItem("flagChangeStepValidationEmail", "true");
          window.dispatchEvent(new Event("storage"));
          window.isValidationEmail = false;
        }
      } else {
        window.history.back();
      }
    } 
    if(eventName === 'ON_DOBLE_BACK'){
      const {
        serviceId, 
        categoryPlansId, 
        paramsNewOfferTelcel
      } = JSON.parse(localStorage.getItem("microappInfo"));
      if(
        (paramsNewOfferTelcel && 
        (
          serviceId === SERVICE_ID_TELCEL_PAQUETES_POSPAGO &&
          categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS
        ) ||
        (
          serviceId === SERVICE_ID_TELCEL_PAQUETES_MIXTOS &&
          categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS_MIXTO
        ) ||
        (
          serviceId === SERVICE_ID_TELCEL_PLANES &&
          categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE
        )) || 
        (paramsNewOfferTelcel && serviceId == SERVICE_ID_TELCEL_POSPAGO)
      ){
        store.dispatch({
          type: "SET_SHOW_LOADER_ON_DOUBLE_BACK",
          payload: true
        })
        setTimeout(() => {
          window.history.back();
        }, 1000);
        setTimeout(() => {
          store.dispatch({
            type: "SET_SHOW_LOADER_ON_DOUBLE_BACK",
            payload: false
          })
        }, 1100); 
      }
    }
    if(eventName === 'refreshCards'){
      store.dispatch({
        type: "SET_PAYMENT_METHOD",
        payload: eventInformation
      });
    }
    if (eventName === getDomiciliationWindowId("nip_response")) {
      const eventInformationObject = JSON.parse(eventInformation);
      const { encodedPin } = eventInformationObject;
      store.dispatch({
        type: "DOMICILIATION_REFERENCE",
        encodedPin: encodedPin
      });
    }
    if (eventName === getDomiciliationWindowId("N2_NOT_NIP") || eventName === getDomiciliationWindowId("NOT_N2")) {
      const eventInformationObject = JSON.parse(eventInformation);
      const { serviceName } = eventInformationObject;
      store.dispatch({
        type: "SET_GO_TO_DOMICILIATION_FORM",
        payload: serviceName,
      });
    }
    if (eventName === "date_picker_response") {
      const eventInformationObject = JSON.parse(eventInformation);
      const { selectedDate } = eventInformationObject;
      store.dispatch({
        type: "SET_DATE_FROM_NATIVE_DATE_PICKER",
        payload: selectedDate,
      });
    }
    if(eventName === "getR1"){
      console.warn("getR1 event intercepted",eventInformation)
      store.dispatch(setCanR1Success(eventInformation))
    }
    if(eventName === "openAddCardForm"){
      store.dispatch({
        type: "OPEN_FLUX_ADD_CARD",
        payload: true
      })
    }
    if(eventName === "openPayMethodModal"){
      store.dispatch({
        type: "OPEN_PAY_METHOD_MODAL",
        payload: true
      })
    }
  }, 
  {}
)

const urlParam = new URLSearchParams(window.location.search);
const activeN2QueryParam = urlParam.get("activeN2");
const hasCreditQueryParam = urlParam.get("hasCredit");
const flags = urlParam.get("flags");
let lineNumber = urlParam.get("accountServiceProvider"); // use this 
const originOfPayment = urlParam.get("originOfPayment");
const bundleVersion = urlParam.get("bundleVersion");
const bundleId = urlParam.get("bundleId");
const parameters = urlParam.get("params");
const paymentAmountFromUrl = urlParam.get("paymentAmount");
const productIdFromUrl = urlParam.get("productId");
const isTemporalClaroId = urlParam.get("isTemporalClaroId");
const goToDomiciliationForm = urlParam.get("goToDomiciliationForm");
const goToMicroappAdelanto = urlParam.get("goToMicroappAdelanto");
const cpso = urlParam.get("cp-so");
const cpbv = urlParam.get("cp-bv");
const paramsOrigin = urlParam.get("params") || "";
const prominentDate = urlParam.get("prominentDate");
store.dispatch({
  type: "SET_CAN_R1",
  payload: Boolean(flags.includes("CAN_R1"))
});

store.dispatch({
  type: "SET_IS_TEMPORAL_CLARO_ID",
  payload: isTemporalClaroId === "true" ? true : false,
});

store.dispatch({
  type: "SET_IS_ANONIMOUS",
  payload: isTemporalClaroId === "true" ? true : false,
});

let params = null;

try {
  params = atob(parameters)
  params = JSON.parse(params)
  console.log("parameters ^|^");
  console.log("           ---");
  console.log(JSON.stringify(params))
} catch {
  params = null;
}

if (params && params.msisdn) {
	lineNumber = params.msisdn
}

store.dispatch({
  type: "SET_IS_CONTAINER_TELCEL",
  payload: BUNDLE_ID_CONTAINER_TELCEL.includes(bundleId) ? true : false
})

store.dispatch({
  type: "GET_PARAMS_FROM_URL",
  params: params,
});

store.dispatch({
  type: "GET_BUNDLE_VERSION_FROM_URL",
  bundleVersion: bundleVersion ? bundleVersion : 0,
});

store.dispatch({
  type: "GET_BUNDLE_ID_FROM_URL",
  bundleId: bundleId ? bundleId : process.env.REACT_APP_CLARO_PAY_BUNDLE_VERSION_DEFAULT,
});

store.dispatch({
  type: "GET_PHONE_NUMBER",
  lineNumber: lineNumber,
});

store.dispatch({
  type: "ORIGIN_OF_PAYMENT",
  originOfPayment: originOfPayment,
});

let activeN2Value =
  activeN2QueryParam === "true" || activeN2QueryParam === null ? true : false;
store.dispatch({
  type: "GET_ACTIVE_FROM_URL",
  activeN2: activeN2Value,
});

let canEncryptValue = flags && flags.includes("CAN_ENCRYPT") ? true : false;
store.dispatch({
  type: "GET_CAN_ENCRYPT",
  canEncrypt: canEncryptValue,
});

let canMultiAnalytics = flags && flags.includes("CAN_MULTIANALYTICS_V2") ? true : false;
store.dispatch({
  type: "GET_CAN_MULTIANALYTICS",
  canMultiAnalytics: canMultiAnalytics,
});

let canTokenComplete = flags && flags.includes("CAN_GET_TOKEN_COMPLETE") ? true : false;
store.dispatch({
  type: "CAN_GET_TOKEN_COMPLETE",
  canTokenComplete: canTokenComplete,
});

let canBarsBisibility = flags && flags.includes("CAN_BARS_VISIBILITY") ? true : false;
store.dispatch({
  type: "GET_CAN_BARS_VISIBILITY",
  canBarsBisibility: canBarsBisibility,
});

let canRegisterEmail = flags && flags.includes("CAN_REGISTER_EMAIL") ? true : false;
store.dispatch({
  type: "CAN_REGISTER_EMAIL",
  canRegisterEmail: canRegisterEmail,
});

let canManageFavorites = flags && flags.includes("CAN_CONTROL_FAVORITES") ? true : false;
store.dispatch({
  type: "GET_CAN_MANAGE_FAVORITES",
  canManageFavorites: canManageFavorites,
});

let canPaymentReminder = flags && flags.includes("CAN_PAYMENT_REMINDER") ? true : false;
store.dispatch({
  type: "GET_CAN_PAYMENT_REMINDER",
  canPaymentReminder: canPaymentReminder,
});

let canFavoriteTooltip = flags && flags.includes("CAN_FAVORITE_TOOLTIP") ? true : false;
store.dispatch({
  type: "GET_CAN_FAVORITE_TOOLTIP",
  canFavoriteTooltip: canFavoriteTooltip,
});

let sendServiceIdValue =
  flags && flags.includes("SEND_SERVICEID") ? true : false;
store.dispatch({
  type: "SEND_SERVICEID",
  canSendServiceId: sendServiceIdValue,
});

let hasCreditValue = hasCreditQueryParam === "true" ? true : false;
store.dispatch({
  type: "GET_HAS_CREDIT_FROM_URL",
  hasCredit: hasCreditValue,
});

const sendClaroSocioValue = flags && flags.includes("SEND_ISCLAROSOCIO") ? true : false;
store.dispatch({
  type: "SEND_ISCLAROSOCIO",
  canSendClaroSocioValue: sendClaroSocioValue,
});

const showCanCookies = flags && flags.includes("CAN_COOKIES") ? true : false;
store.dispatch({
  type: "SHOW_CAN_COOKIES",
  canShowCanCookies: showCanCookies,
});

const showNewOfferTelcel = flags && flags.includes("SHOW_NEW_OFFER_TELCEL") ? true : false;
store.dispatch({
  type: "SHOW_NEW_OFFER_TELCEL",
  canShowNewOfferTelcel: showNewOfferTelcel,
});

store.dispatch({
  type: "GET_PAYMENT_AMOUNT_FROM_URL",
  payload: paymentAmountFromUrl,
});

store.dispatch({
  type: "GET_PRODUCT_ID_FROM_URL",
  payload: productIdFromUrl,
});

store.dispatch({
  type: "CAN_CALL_NIP",
  canCallNip: !!flags && flags.includes("CAN_CALL_NIP"),
});

store.dispatch({
  type: "CAN_UPSELL_N2",
  canUpsellN2: !!flags && flags.includes("CAN_UPSELL_N2"),
});

store.dispatch({
  type: "SET_GO_TO_DOMICILIATION_FORM",
  payload: goToDomiciliationForm === "true",
});

store.dispatch({
  type:"GET_GO_TO_MICROAPPADELANTO",
  payload: goToMicroappAdelanto
})

let canGetAppSync = flags && flags.includes("CAN_APPSYNC") ? true : false;
store.dispatch({
  type: "CAN_GET_APPSYNC",
  canGetAppSync: canGetAppSync,
});
store.dispatch({
  type: "SET_BUNDLE_PARAMS_FROM_URL",
  payload : {
    cpso,
    cpbv,
    bundleId
  }
})
let canGetScanner =  flags && flags.includes("CAN_SCANNER") ? true : false;
store.dispatch({
  type: "GET_CAN_SCANNER",
  canGetScanner: canGetScanner,
});

const values = paramsOrigin.split(',');
const index = values.indexOf('analyticOrigin');

let originParamValue = index !== -1 && index + 1 < values.length ? ('analyticOrigin,' + values[index + 1]) : null;
store.dispatch({
  type: "ORIGIN_PARAM",
  originParamValue: originParamValue,
});

store.dispatch({
  type: "GET_PROMINENT_DATE",
  payload: prominentDate ? true : false,
});

store.dispatch({
	type: "CAN_ADVANCE_MEGAS",
	payload: flags.includes("CAN_ADVANCE_MEGAS")
});


// Initialize SDK Web (Using for add card - Anonimous user)
useClaropaySdk().initialize(bundleId, bundleVersion);

ReactDOM.render(
  <AppMain store={store} history={history} />,
  document.getElementById("root")
);

serviceWorker.unregister();

